import {Button, Input, message, Modal} from "antd"
import Highlighter from 'react-highlight-words'
import {localStorageKey} from '@/config/config'
import config from '@/config/env'
import jldz from '@/assets/images/交流定子.jpg';
import sdgj from '@/assets/images/手动工具.jpg';
import zj from '@/assets/images/整机.jpg';
import zdz from '@/assets/images/转定子.jpg';
import fj from '@/assets/images/附件.jpg';
import lpj from '@/assets/images/零配件.jpg';

export const successAlert = (message, callback?) => {
    Modal.success({
        title: '提示',
        content: message,
        onOk() {
            if (typeof callback === 'function') {
                callback()
            }
        }
    })
}

export const alert = (title, message, callback?) => {
    Modal.info({
        title,
        content: (
            <div>
                <p>{message}</p>
            </div>
        ),
        onOk() {
            if (callback && typeof callback === 'function') {
                callback();
            }
        },
    });
}

export const confirm = (message, title = '温馨提示') => {
    return new Promise((resolve, reject) => {
        Modal.confirm({
            title,
            content: (
                <div>
                    <p>{message}</p>
                </div>
            ),
            okText: "是",
            cancelText: "否",
            onOk() {
                resolve(true)
            },
            onCancel() {
                resolve(false)
            },
        });
    })
}

export const getLocalstorage = (key) => {
    const val = window.localStorage.getItem(localStorageKey + key)
    if (!val) {
        return null
    }
    return JSON.parse(val).value
}
export const getLocalstorageWithsk = (sk,key) => {
    const val = window.localStorage.getItem(sk + key)
    if (!val) {
        return null
    }
    return JSON.parse(val).value
}

export const setLocalstorage = (key, value, sk=localStorageKey) => {
    window.localStorage.setItem(sk + key, JSON.stringify({
        value
    }))
}

let searchText = ''
const handleCloumnSearch = (selectedKeys, confirm) => {
    confirm();
    // this.setState({ searchText: selectedKeys[0] });
    searchText = selectedKeys[0];
};

const handleCloumnReset = clearFilters => {
    clearFilters();
    // this.setState({ searchText: '' });
    searchText = "";
};

export const getColumnSearchProps = (dataIndex, placeholder) => ({
    filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters}) => (
        <div style={{padding: 8}}>
            <Input
                ref={node => {
                    // this.searchInput = node;
                }}
                placeholder={`请输入${placeholder}`}
                value={selectedKeys[0]}
                onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                onPressEnter={() => handleCloumnSearch(selectedKeys, confirm)}
                style={{width: 188, marginBottom: 8, display: 'block'}}
            />
            <Button
                type="primary"
                onClick={() => handleCloumnSearch(selectedKeys, confirm)}
                icon="search"
                size="small"
                style={{width: 90, marginRight: 8}}
            >
                搜索
            </Button>
            <Button onClick={() => handleCloumnReset(clearFilters)} size="small" style={{width: 90}}>
                重置
            </Button>
        </div>
    ),
    // filterIcon: filtered => (
    //   <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    // ),
    onFilter: (value, record) => {
        if (record[dataIndex]) {
            return record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase());
        }
        return false;
    },
    onFilterDropdownVisibleChange: visible => {
        if (visible) {
            // setTimeout(() => this.searchInput.select());
        }
    },
    render: text => {
        // const { searchText } = this.state;
        return <Highlighter
            highlightStyle={{backgroundColor: '#ffc069', padding: 0}}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ""}
        />
    },
});

// 复制
export const copyTextToClipboard = async (text) => {
    try {
        await navigator.clipboard.writeText(text);
        message.success('内容已复制到剪贴板')
    } catch (err) {
        console.error('复制到剪贴板失败', err);
    }
}

export const replaceURL = (url) => {
    if (url) {
        url = url.replace(/http:\/\/dms.dcatools.cn:8180/gi, "");
        url = url.replace(/http:\/\/gdms.dcatools.cn:8180/gi, "");
        url = url.replace(/http:\/\/mdms.dcatools.cn:8180/gi, "");
        url = url.replace(/http:\/\/file.dcatools.cn:8180/gi, "");
        url = url.replace(/https:\/\/dms.dcatools.cn:8180/gi, "");
        url = url.replace(/https:\/\/gdms.dcatools.cn:8180/gi, "");
        url = url.replace(/https:\/\/mdms.dcatools.cn:8180/gi, "");
        url = url.replace(/http:\/\/crm.china-dongcheng.com:8180/gi, "");
        url = url.replace(/http:\/\/gcrm.china-dongcheng.com:8180/gi, "");
        url = url.replace(/http:\/\/mcrm.china-dongcheng.com:8180/gi, "");
        url = url.replace(/http:\/\/10.9.9.18:8180/gi, "");
        url = url.replace(/https:\/\/crm.china-dongcheng.com:8180/gi, "");
        url = url.replace(/https:\/\/gcrm.china-dongcheng.com:8180/gi, "");
        url = url.replace(/https:\/\/mcrm.china-dongcheng.com:8180/gi, "");
        url = url.replace(/https:\/\/10.9.9.18:8180/gi, "");
        url = url.replace(/https:\/\/file.dcatools.cn:8180/gi, "");
        url = url.replace(/https:\/\/10.9.9.18:8080/gi, "");
        url = url.replace(/http:\/\/dms.dcatools.cn/gi, "");
        url = url.replace(/http:\/\/gdms.dcatools.cn/gi, "");
        url = url.replace(/http:\/\/mdms.dcatools.cn/gi, "");
        url = url.replace(/http:\/\/file.dcatools.cn/gi, "");
        url = url.replace(/https:\/\/dms.dcatools.cn/gi, "");
        url = url.replace(/https:\/\/gdms.dcatools.cn/gi, "");
        url = url.replace(/https:\/\/mdms.dcatools.cn/gi, "");
        url = url.replace(/http:\/\/crm.china-dongcheng.com/gi, "");
        url = url.replace(/http:\/\/gcrm.china-dongcheng.com/gi, "");
        url = url.replace(/http:\/\/mcrm.china-dongcheng.com/gi, "");
        url = url.replace(/http:\/\/10.9.9.18/gi, "");
        url = url.replace(/https:\/\/crm.china-dongcheng.com/gi, "");
        url = url.replace(/https:\/\/gcrm.china-dongcheng.com/gi, "");
        url = url.replace(/https:\/\/mcrm.china-dongcheng.com/gi, "");
        url = url.replace(/https:\/\/10.9.9.18/gi, "");
        url = url.replace(/https:\/\/file.dcatools.cn/gi, "");
        return config.urlPrefix + url;
    }
    return "";
}

export const isInteger = (obj) => {
    return Math.floor(obj) === obj
}

export const toInteger = (floatNum) => {
    const ret = {times: 1, num: 0};
    if (isInteger(floatNum)) {
        ret.num = floatNum;
        return ret
    }
    const strfi = `${floatNum}`;
    const dotPos = strfi.indexOf('.');
    const len = strfi.substr(dotPos + 1).length;
    const times = Math.pow(10, len);
    const intNum = parseInt(floatNum * times + 0.5 + '', 10);
    ret.times = times;
    ret.num = intNum;
    return ret
}

export const operation = (a, b, op) => {
    const o1 = toInteger(a);
    const o2 = toInteger(b);
    const n1 = o1.num;
    const n2 = o2.num;
    const t1 = o1.times;
    const t2 = o2.times;
    const max = t1 > t2 ? t1 : t2;
    let result = null;
    switch (op) {
        case 'add':
            if (t1 === t2) { // 两个小数位数相同
                result = n1 + n2
            } else if (t1 > t2) { // o1 小数位 大于 o2
                result = n1 + n2 * (t1 / t2)
            } else { // o1 小数位 小于 o2
                result = n1 * (t2 / t1) + n2
            }
            return result / max;
        case 'subtract':
            if (t1 === t2) {
                result = n1 - n2
            } else if (t1 > t2) {
                result = n1 - n2 * (t1 / t2)
            } else {
                result = n1 * (t2 / t1) - n2
            }
            return result / max;
        case 'multiply':
            result = (n1 * n2) / (t1 * t2);
            return result;
        case 'divide':
            result = (n1 / n2) * (t2 / t1);
            return result;
        default:
            return 0;
    }
};

export const compute = (n1, n2, fh) => {
    n1 = Number(n1);
    n2 = Number(n2);
    const n1l = n1.toString().split(".");
    const n2l = n2.toString().split(".");
    let pow1 = 0;
    let base1 = 0;
    if (fh === "+") {
        if (n1l.length > 1 && n2l.length > 1) {
            pow1 = Math.max(n1l[1].length, n2l[1].length);
            base1 = Math.pow(10, pow1);
            return (Math.round(n1 * base1) + Math.round(n2 * base1)) / base1;
        }
        if (n1l.length > 1) {
            base1 = Math.pow(10, n1l[1].length);
            return (Math.round(n1 * base1) + Math.round(n2 * base1)) / base1;
        }
        if (n2l.length > 1) {
            base1 = Math.pow(10, n2l[1].length);
            return (Math.round(n1 * base1) + Math.round(n2 * base1)) / base1;
        }
        return Math.round(n1 + n2);
    }
    if (fh === "-") {
        if (n1l.length > 1 && n2l.length > 1) {
            pow1 = Math.max(n1l[1].length, n2l[1].length);
            base1 = Math.pow(10, pow1);
            return (Math.round(n1 * base1) - Math.round(n2 * base1)) / base1;
        }
        if (n1l.length > 1) {
            base1 = Math.pow(10, n1l[1].length);
            return (Math.round(n1 * base1) - Math.round(n2 * base1)) / base1;
        }
        if (n2l.length > 1) {
            base1 = Math.pow(10, n2l[1].length);
            return (Math.round(n1 * base1) - Math.round(n2 * base1)) / base1;
        }
        return Math.round(n1 - n2);
    }
    if (fh === "*") {
        if (n1l.length > 1 && n2l.length > 1) {
            pow1 = Math.max(n1l[1].length, n2l[1].length);
            base1 = Math.pow(10, pow1);
            return (Math.round(n1 * base1) * Math.round(n2 * base1)) / Math.round(base1 * base1);
        }
        if (n1l.length > 1) {
            base1 = Math.pow(10, n1l[1].length);
            return Math.round(n1 * base1 * n2) / base1;
        }
        if (n2l.length > 1) {
            base1 = Math.pow(10, n2l[1].length);
            return Math.round(n2 * base1 * n1) / base1;
        }
        return Math.round(n1 * n2);
    }
    if (fh === "/") {
        if (n1l.length > 1 && n2l.length > 1) {
            pow1 = Math.max(n1l[1].length, n2l[1].length);
            base1 = Math.pow(10, pow1);
            return Math.round(n1 * base1) / Math.round(n2 * base1);
        }
        if (n1l.length > 1) {
            base1 = Math.pow(10, n1l[1].length);
            return Math.round(n1 * base1) / Math.round(n2 * base1);
        }
        if (n2l.length > 1) {
            base1 = Math.pow(10, n2l[1].length);
            return Math.round(n1 * base1) / Math.round(n2 * base1);
        }
        return Math.round(n1) / Math.round(n2);
    }
}

export const numberFormat = (num, ws, display = false) => {
    const n1 = roundToFixed(Number(num), ws) ;
    if (display === true) {
        return Number(n1);
    }
    return Number(n1);
}
export const roundToFixed = (num,ws, returnString = false) => {
    let result = 0;
    if(ws===1){
        result = Math.round(Number(num) * 10) / 10;
    }else if(ws===2){
        result =  Math.round(Number(num) * 100) / 100;
    }else if(ws===3){
        result =  Math.round(Number(num) * 1000) / 1000;
    }else if(ws===4){
        result =  Math.round(Number(num) * 10000) / 10000;
    }
    return returnString ? result.toFixed(ws) : result;
}

export const sleep = (time) => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(true)
        }, time)
    })
}

// 获取产品图片
export const getPic = (data) => {
    if (data.lbt) {
        return replaceURL(data.lbt)
    } else if (data.spart === '10') {
        // 整机
        return zj
    } else if (data.lbbm && data.lbbm.length > 3 && data.lbbm.substr(0, 4) === '1105') {
        // 交流定子
        return jldz
    } else if (data.spart === '11') {
        // 转定子(电机)
        return zdz
    } else if (data.spart === '12') {
        // 零配件
        return lpj
    } else if (data.spart === '13') {
        // 附件
        return fj
    } else if (data.spart === '30') {
        // 手动工具
        return sdgj
    }
}
// 获取产品图片
export const getDlmc = (data) => {
    const cpdl = data.prdha && data.prdha.length > 3 ? data.prdha.substr(0, 3) : ''
    if (cpdl==='001') {
        return "整机"
    } else if (cpdl==='002') {
        return "电机"
    }else if (cpdl==='003') {
        return "配件"
    }else if (cpdl==='004') {
        return "附件"
    }else if (cpdl==='005') {
        return "手动工具"
    }else if (cpdl==='006') {
        return "机电产品"
    }else if (cpdl==='007') {
        return "集采产品"
    }else {
        return "-";
    }
}

export const isEmpty = (val) => {
    return ['', null, undefined].includes(val)
}

export const numFormat = (num) => {
    const res = num.toString().replace(/\d+/, function (n) { // 先提取整数部分
        return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
            return `${$1},`;
        });
    })
    return res;
}
export const preciseToFixed=(num: number, decimal: number)=> {
    const factor = Math.pow(10, decimal);
    return (Math.round(num * factor) / factor).toFixed(decimal);
}